import type { PaginationData } from "./pagination.model";
import { KycStatus } from "./user.model";
import { BackendEvaluationType } from "./evaluationTypeMapping.model";

export enum ContractStatus {
  PENDING = "PENDING",
  DENIED = "DENIED",
  APPROVED = "APPROVED",
  READY_TO_CREATE = "READY_TO_CREATE",
  READY_TO_SEND = "READY_TO_SEND",
  READY_TO_SIGN = "READY_TO_SIGN",
  SIGNED = "SIGNED",
}

export interface Contract {
  phase2ChallengeId: string;
  phase2Account: string;
  accountSize: string | undefined;
  planetName: string;
  kycStatus: KycStatus;
  contractStatus: ContractStatus;
  evaluationType: BackendEvaluationType | undefined;
  /** Purchase order UUID of an Instant account whose trading account does not exist yet. */
  orderId?: string;
}

export type ContractsPaginated = PaginationData<Contract>;
